export const useGetIsDemoDepartment = (demoDepartments, fireDepartment) => {
  let isDemo = false
  if (demoDepartments && fireDepartment) {
    demoDepartments.forEach((el) => {
      if (el.identifier === fireDepartment.identifier) {
        isDemo = true
      }
    })
  }

  return { isDemo }
}
